import { render } from "./CreateMatch.vue?vue&type=template&id=63b5555e"
import script from "./CreateMatch.vue?vue&type=script&lang=js"
export * from "./CreateMatch.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__